import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type MalleableUiPluginState = {
	isRemixModalOpen: boolean;
};

export const malleableUiPluginKey = new PluginKey<MalleableUiPluginState>('malleableUiPlugin');

export function createMalleableUiPmPlugin(dispatch: Dispatch): SafePlugin {
	return new SafePlugin({
		key: malleableUiPluginKey,
		state: {
			init(): MalleableUiPluginState {
				return { isRemixModalOpen: false };
			},
			apply(tr, pluginState): MalleableUiPluginState {
				const meta = tr.getMeta(malleableUiPluginKey);
				if (meta) {
					const newState = { ...pluginState, ...meta };
					dispatch(malleableUiPluginKey, newState);
					return newState;
				}
				return pluginState;
			},
		},
	});
}
